<template>
  <div class="home login-home">
    <header class="home-header admin-header">
       <router-link to="/" class="">
        <img
          class="logo"
          src="./../assets/header/logo.png"
          alt="沐桦科技"
        />
       </router-link>
    </header>
    <section class="content user-content login-content">
      <section class="content-wrap">
        <div class="account-dialog login-dialog">
          <div class="title">登陆</div>
          <!-- 邮箱 -->
          <BasicInput
            type="text"
            icon-type="email"
            class="account-input account-email login-account-email"
            v-model="inputEmail"
            text="邮箱"
          ></BasicInput>
          <div
            v-if="EmailErrorMsg"
            class="account-error"
          >
            <i class="el-alert__icon el-icon-error"></i>
            <span class="EmailErrorMsg">{{ EmailErrorMsg }}</span>
          </div>
          <BasicInput
            type="password"
            icon-type="password"
            class="account-input password-email"
            v-model="inputPassword"
            needKeyEnter=true
            @keyUpEnter="startLogin"
            text="密码"
          ></BasicInput>
          <div
            v-if="passwordErrorMsg"
            class="account-error"
          >
            <i class="el-alert__icon el-icon-error"></i>
            <span class="passwordErrorMsg">{{ passwordErrorMsg }}</span>
          </div>

          <!--  登陆 -->
          <div
            class="login bonus-cursor"
            v-on:click="startLogin"
          >登陆
          </div>
          <div class="login-sign-wrap">
            <div
              class="login-forget bonus-cursor"
              v-on:click="signUp"
            >注册
            </div>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";
import BasicInput from "@/components/BasicInput.vue";
import { Message } from "element-ui";

export default {
  name: "home",
  components: {
    Footer,
    Menu,
    BasicInput
  },
  data() {
    return {
      activeIndex: "1",
      inputEmail: "",
      EmailErrorMsg: "",
      inputPassword: "",
      passwordErrorMsg: ""
    };
  },
  computed: mapState({}),
  created() {},
  methods: {
    ...mapActions(["login"]),
    // 忘记密码
    signUp() {
      this.$router.push({ name: "SignUp" });
    },
    startLogin() {
      const { inputEmail, inputPassword, isLoginDisable, response } = this;
      if (isLoginDisable) {
        return true;
      }
      // 邮箱正则表达式-----后续建议提出来统一维护
      const emailRule = /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,6}){1,2})$/;
      if (emailRule.test(inputEmail)) {
        this.EmailErrorMsg = "";
      } else {
        this.EmailErrorMsg = "The email error";
        return true;
      }
      // 密码校验
      if (inputPassword.length >= 6 && inputPassword.length < 30) {
        this.passwordErrorMsg = "";
      } else {
        this.passwordErrorMsg = "The password is too small or too long";
        return true;
      }

      this.isLoginDisable = true;
      this.login({ email: inputEmail, password: inputPassword, response }).then(
        res => {
          if (res.code === 200) {
            Message({
              message: "登陆成功",
              type: "success"
            });
            setTimeout(() => {
              this.$router.push({ name: "Admin" });
            }, 2000);
          } else {
            this.isLoginDisable = false;
            Message({
              message: res.message || "网络出错，请重试",
              type: "error"
            });
          }
        }
      );
    }
  }
};
</script>

<style lang="stylus">
#app, .login-home {
  height: 100%;
}

.logo {
  width: 126px;
  height: 40px;
  margin: 10px 0;
}

.user-content {
  width: 98%;
  background: rgba(20, 31, 33, 1);
  margin-top: -60px;
}

.home {
  height: 100%;
}

.login-content {
  display: flex;
  justify-content: center;
  // align-items: center;
}

.content-wrap {
  width: 990px;
  height: 314px;
  background-size: cover;
  margin-top: 250px;
}

.account-dialog {
  margin: 0 0 0 60%;
  width: 52%;
  background: #fff;
  border: 1px solid #e3e3e7;
  width: 293px;
  height: 314px;
}

.account-dialog.login-dialog {
  margin: 0 0 0 60%;
  width: 52%;
  background: #fff;
  border: 1px solid #e3e3e7;
  // width: 293px;
  // height: 260px;
  width: 293px;
  height: 314px;
}

.account-dialog .title {
  font-family: PingFangSC-Semibold;
  color: #65686A;
  font-size: 12px;
  line-height: 12px;
  padding: 30px 0 30px;
  text-align: center;
}

.account-dialog .title {
  font-size: 14px;
  line-height: 14px;
  padding: 35px auto 35px;
  text-align: cneter;
}

.input-wrap {
  margin: 10px 40px 20px 40px;
}

.login, .sign-up-button {
  box-sizing: border-box;
  margin: 35px 80px 10px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background: rgba(0, 174, 239, 1);
  border-radius: 4px;
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
}

.account-input {
  margin: 0 30px;
}

.BasicInput.account-input.password-email {
  margin-top: 12px;
}

.login-sign-wrap {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #13B8BC;
  text-align: justify;
  line-height: 36px;
  margin: 0 30px 35px;
  display: flex;
  justify-content: center;
}

.login-forget {
  font-size: 12px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(0, 174, 239, 1);
  line-height: 24px;
}

.content-wrap {
  background-image: url('../assets/user/bg.png');
}

.account-error {
  box-sizing: border-box;
  padding: 5px 30px 0;
  color: #EE4035;
  font-size: 10px;
}

@media screen and (min-width: 1920px) {
  .content-wrap {
    width: 1320px;
    height: 418px;
    background-size: cover;
    margin-top: 250px;
  }

  .account-dialog {
    margin: 0 0 0 60%;
    width: 52%;
    background: #fff;
    border: 1px solid #e3e3e7;
    width: 392px;
    height: 326px;
    margin-top: 46px;

    .login-dialog {
      // width: 300px;
      // height: 330px;
      width: 350px;
      height: 386px
    }

    .title {
      font-size: 20px;
      text-align: center;
      padding: 22px 0 52px;
      line-height: 30px;
    }

    .BasicInput.account-input.password-email {
      margin-top: 24px;
    }

    .BasicInput {
      height: 36px;
      margin-top: 0px;
    }

    .login, .sign-up-button {
      margin: 52px 80px 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
    }

    input.basic-input {
      height: 36px;
      line-height: 36px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(224, 224, 224, 1);
    }

    .icon-wrap {
      line-height: 36px;
    }
  }

  .account-dialog.login-dialog {
    // width: 330px;
    // height: 340px;
    width: 350px;
    height: 386px
  }
}

.account-error {
  text-align: center;
}


.login-account-email.account-input {
  margin-top: 18px;
}

.password-email{
  margin-top: 27px;
}

@media screen and (min-width: 1920px) {
  .login-account-email.account-input {
    margin-top: 0px !important;
  }

  .login{
    margin-top: 30px;
  }
}
</style>
